<section class="mtb-30 mt-80 jobConfirm-sec">
    <div class="container text-section">
        <lib-apply-confirmation [message]="message"></lib-apply-confirmation>
    </div>
</section>
